export const module = {
  info: {
    name: 'voip-reseller',
    caption: 'voip reseller',
    viewGroup: 'users'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Resellers Rates',
    icon: 'el-icon-user',
    routeName: 'module->voip-reseller->list->page',
    routeParams: { listPage: 1}
  }
}

export default module
